import { useBoolean } from './useBoolean.js';

/**
 * Wrapper for useBoolean which only allows toggling the value, and thus the
 * return value can support array destructuring that is typical of React hooks.
 */

var useToggle = function useToggle() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useBoolean = useBoolean(initialState),
      value = _useBoolean.value,
      toggle = _useBoolean.toggle;

  return [value, toggle];
};

export { useToggle };
